





import { Box,  useMediaQuery,MenuItem, Select,Grid, Typography, Button } from '@mui/material';
import DashboardCard from '../../../components/Cards/DashboardCard';
import dashboardlogo1 from "../../../assets/Dashboard/dashboardlogo1.svg";
import dashboardlogo2 from "../../../assets/Dashboard/request.svg";
import dashboardlogo3 from "../../../assets/Dashboard/dashboardlogo3.svg";
import dashboardlogoq0 from "../../../assets/Dashboard/RequestBlack.svg";
import dashboardlogo4 from "../../../assets/Dashboard/dashboardlogo4.svg";
import dashboardlogo8 from "../../../assets/Dashboard/active.svg";
import dashboardlogo5 from "../../../assets/Dashboard/dashboardlogo5.svg";
import dashboardlogo9 from "../../../assets/Dashboard/inactive1.svg";
import graphicon from "../../../assets/Dashboard/graphicon.svg";
import dollarsign from "../../../assets/Dashboard/dollarsign.svg";
import dashboardmap from "../../../assets/Dashboard/dashboardmap.png";
import CustomButton from '../../../components/CustomButton';
import ClientAcquisitionTable from "./DashboardClients";
import PayoutsDonutChart from './PayoutChart';
import PayoutLogsTable from './DashboardPayoutTable';
import InviteDetails from '../ClientAcquisition/InvitedClients/ClientsDetails';
import DashboardPins from './DashboardPins';
import maparrow from "../../../assets/maparrow.svg";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {showUnderDevelopment} from '../../../components/alerts';
import { useState,useRef,useEffect } from 'react';
import { useLayoutEffect } from 'react';
import { BASE_URL } from '../../../components/BaseUrl';
import { decryptToken } from "../../../Utlis/Encryption";
import { useSelector } from "react-redux";
import ClientGrowthmap from './ClientGrowthmap';
import MapCities from './MapCities';
import RequestGraph from './RequestGraph';
import {toast} from "react-hot-toast"
import { formatNumber } from "../../../Utlis/formatNumber";


import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from 'recharts';





const Dashboard = () => {
  const { t } = useTranslation();
  
const navigate=useNavigate()


  const isMobile = useMediaQuery('(max-width:768px)');
    const [isExpanded, setIsExpanded] = useState(false);
     const rawEncryptedToken = localStorage.getItem("token")
      const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null

const [selectedRow, setSelectedRow] = useState(null);
 const [selectedInvite, setSelectedInvite] = useState(null);
  const topSentinelRef = useRef(null);



  useLayoutEffect(() => {
  if (!selectedInvite) return;
  requestAnimationFrame(() => {
    // Step 1: scroll the sentinel into view
    topSentinelRef.current?.scrollIntoView({ behavior: 'auto', block: 'start' });

    // Step 2: adjust by your offset (in px)
    const offset = 48; // ~3rem / adjust to match your desired "gap from top"
    const scroller = (() => {
      // Find the nearest scrollable ancestor
      let node = topSentinelRef.current?.parentElement;
      while (node && node !== document.body) {
        const style = window.getComputedStyle(node);
        const oy = style.overflowY;
        if ((oy === 'auto' || oy === 'scroll') && node.scrollHeight > node.clientHeight) {
          return node;
        }
        node = node.parentElement;
      }
      return window; // fallback
    })();

    if (scroller === window) {
      window.scrollBy({ top: -offset, behavior: 'auto' });
    } else {
      scroller.scrollBy({ top: -offset, behavior: 'auto' });
    }
  });
}, [selectedInvite]);



   const execIdFromRedux = useSelector((s) => s.auth?.user?.id); // <-- replace with your real path
  const executiveId = execIdFromRedux // fallback for testing
 console.log("id from redux...", executiveId)
  const [stats, setStats] = useState(null);

  useEffect(() => {
    if (!executiveId || !token) return;

    fetch(`${BASE_URL}/account-executive/${executiveId}/statistics/dashboard`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((res) => {
          console.log("AE Dashboard API Response:", res); 
        if (!res.error) {
          setStats(res.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching dashboard stats:", err);
      });
  }, [executiveId, token]);
const [referralLink, setReferralLink] = useState("");
useEffect(() => {
  if (!token) return;

  const controller = new AbortController();

  async function fetchReferralLink() {
    try {
      const res = await fetch(`${BASE_URL}/account-executive/referral-link`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        signal: controller.signal,
      });

      const json = await res.json();
      if (!json.error) {
        setReferralLink(json.data.invitation_link);
      }
    } catch (err) {
      console.error("Error fetching referral link:", err);
    }
  }

  fetchReferralLink();
  return () => controller.abort();
}, [token]);
  return (
    <Box
   
    sx={{ pl:isMobile?0.5: 1.5,pr:isMobile?0.5:0, py: 2,}}>
       {/* {selectedInvite && (
          <Box sx={{ mt: 2 }}>
            <InviteDetails
          selectedRow={selectedInvite}
             onClose={() => setSelectedInvite(null)}
           />           </Box>
        )} */}
          <div ref={topSentinelRef} />
 {selectedInvite ? (
      /* ✅ SHOW ONLY DETAILS (full takeover) */
      <InviteDetails
        selectedRow={selectedInvite}
        onClose={() => setSelectedInvite(null)} // make sure InviteDetails calls this
      />
    ) : (
  
      <>
    
  {/* {isExpanded ? (
    // <ViewFull setIsExpanded={setIsExpanded}/>
  ) : (
    <> */}




 <Box
  sx={{
    mt: 1,
    display: "grid",
    gap: 2,
    gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
  }}
>


<Box
  sx={{
    p: 2,
    border: "2px solid #091E4224",
    borderRadius: 4,
    backgroundColor: "#fff",
    display: "flex",
    flexDirection: "column",
    gap: 1,
    height: "100%",
  }}
>
  <Typography
    sx={{
      fontSize: "18px",
      fontWeight: 600,
      fontFamily: "Poppins, sans-serif",
      mb: 1,
      pt: 2,
    }}
  >
    {t("dashboard.cards.affiliateLink")}
  </Typography>

  {/* Link + Button in same row */}
  <Box sx={{ display: "flex", alignItems: "center", gap: 2 , mt:1}}>
    <Box
      sx={{
        flex: 1,
        border: "1px solid #ddd",
        borderRadius: 1,
        padding: "8px 10px",
        backgroundColor: "#fafafa",
      }}
    >
      <Typography
        sx={{
          fontSize: "16px",
          fontFamily: "Poppins, sans-serif",
          color: "#181818",
          whiteSpace: "nowrap",
          overflow: "hidden",
          fontWeight: 400,
          textOverflow: "ellipsis",
        }}
      >
        {referralLink ? referralLink : "..."}
      </Typography>
    </Box>

    <CustomButton
      label={t("copy")}
      onClick={() => {
        if (referralLink) {
          navigator.clipboard.writeText(referralLink);
          toast.success(t("dashboard.cards.linkCopied"));
        }
      }}
      size="medium"
    />
  </Box>
</Box>


  <Box
    sx={{
      display: "grid",
      gap: 2,
      gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
    }}
  >
        <DashboardCard
          icon={dashboardlogo1}
          title={
            t('sidebar.invited_clients') 
              
          }
          description={stats ? formatNumber(stats.companies.invited) : t('no_data_yet')}
          onClick={() => navigate('/invited-clients', { state: { fromDashboard: true } })}
        />
        <DashboardCard
          icon={dashboardlogo2}
          title={t('sidebar.client_request', t('ClientsRequests.title'))}
          description={stats ? formatNumber(stats.companies.requested) : t('no_data_yet')}
          onClick={() => navigate('/clients-requests', { state: { fromDashboard: true } })}
        />
        <DashboardCard
          icon={dollarsign}
          title={t('total_earned')}
          description={stats ? formatNumber(stats.commissions.total_earned, true) : t('no_commission')}
          onClick={() => navigate('/my-wallet', { state: { fromDashboard: true } })}
        />
        <DashboardCard
          icon={dashboardlogo3}
          title={t('Received Earnings')}
          description={stats ? formatNumber(stats.commissions.paid, true) : t('no_commission')}
          onClick={() => navigate('/my-wallet', { state: { fromDashboard: true } })}
        />
    
        <DashboardCard
          icon={dashboardlogo5}
          title={t('Pending Earnings')}
          description={stats ? formatNumber(stats.commissions.pending, true) : t('no_commission')}
          onClick={() => navigate('/my-wallet', { state: { fromDashboard: true } })}
        />
        <DashboardCard
          icon={dashboardlogo9}
          title={t('dashboard.cards.inactiveCompanies', t('Inactive Companies'))}
          description={stats ? formatNumber(stats.companies.inactive) : t('no_data_yet')}
          onClick={() => navigate('/inactive-companies', { state: { fromDashboard: true } })}
        />
        <DashboardCard
          icon={dashboardlogo8}
          title={t('dashboard.cards.activeCompanies', t('Active Companies'))}
          description={stats ? formatNumber(stats.companies.active) : t('no_data_yet')}
          onClick={() => navigate('/active-companies', { state: { fromDashboard: true } })}
        />
        <DashboardCard
          icon={dashboardlogoq0}
          title={t('dashboard.cards.onTrial', t('On Trial'))}
          description={stats ? formatNumber(stats.companies.trial) : t('no_data_yet')}
          onClick={() => navigate('/clients-trial', { state: { fromDashboard: true } })}
        />




  </Box>
</Box>

      <Box sx={{ mt: 4, display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' } }}>
 
        <ClientGrowthmap/>
<RequestGraph/>
        

      </Box>
 
{/* <MapCities/> */}
<Box sx={{ mt: 2, width: '100%', overflowX: 'auto' }}>
 <DashboardPins/>

</Box>


{/* <Box sx={{ mt: 2, width: '100%', overflowX: 'auto' }}>
  <ClientAcquisitionTable  onShowDetails={setSelectedInvite}/>

</Box> */}

<Box sx={{ width: '100%', overflowX: 'hidden', px: 0 ,mt:1}}>
  <Grid
    container
    spacing={1}
    sx={{
      width: '100%',
      margin: 0,
      flexWrap: { xs: 'wrap', md: 'nowrap' }
    }}
  >
    {/* Donut Chart - 30% on md+ screens */}
    {/* <Grid
      item
      xs={12}
      md={4}
      sx={{ flex: { md: '0 0 29%' }, maxWidth: { md: '29%' }, width: '100%' }}
    >
      <Box sx={{ width: '100%' }}>
        <PayoutsDonutChart />
      </Box>
    </Grid> */}

    {/* Table - 70% on md+ screens */}
    <Grid
      item
      xs={12}
      md={8}
      sx={{ 
        // flex: { md: '0 0 70%' }, maxWidth: { md: '70%' },
       width: '100%' }}
    >
      <Box
        sx={{
          width: '100%',
          overflowX: 'auto',
        }}
      >
        <PayoutLogsTable />
      </Box>
    </Grid>
  </Grid>
</Box>
 </>

  )}
    </Box>
  );
};
export default Dashboard;